var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKingLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.482422,
    y: 0.839905,
    width: 48,
    height: 48,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_2982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1991 28.7282L12.7733 19.461C12.6679 18.7767 13.4476 18.3095 14.0015 18.7251L18.4437 22.0564C18.5591 22.1429 18.691 22.2049 18.8313 22.2387C18.9715 22.2726 19.1172 22.2775 19.2594 22.2531C19.4016 22.2288 19.5373 22.1757 19.6583 22.0971C19.7793 22.0186 19.8831 21.9162 19.9632 21.7962L23.6616 16.2493C24.0523 15.6634 24.9132 15.6634 25.3038 16.2493L29.0023 21.7962C29.0824 21.9162 29.1861 22.0186 29.3071 22.0971C29.4281 22.1757 29.5639 22.2288 29.7061 22.2531C29.8483 22.2775 29.9939 22.2726 30.1342 22.2387C30.2744 22.2049 30.4063 22.1429 30.5218 22.0564L34.964 18.7251C35.5187 18.3095 36.2976 18.7767 36.1921 19.461L34.7663 28.7282H14.1991ZM33.6937 33.8704H15.2718C15.1309 33.8704 14.9914 33.8427 14.8613 33.7888C14.7312 33.7349 14.6129 33.6559 14.5133 33.5562C14.3121 33.3551 14.1991 33.0823 14.1991 32.7978V30.4423H34.7663V32.7978C34.7663 33.39 34.2858 33.8704 33.6937 33.8704Z",
    fill: "#FFB743"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_2982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(11.9824 12.3399)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingLogoIcon);
export default __webpack_public_path__ + "static/media/king-logo-icon.dfb271105df335f65c580e7623eaf24d.svg";
export { ForwardRef as ReactComponent };